(() => {
  angular
    .module('gm.common.directives')
    .directive('gmyButtonDisabled', gmyButtonDisabled);

  function gmyButtonDisabled() {
    'ngInject';

    return {
      link,
      restrict: 'A',
      scope: {
        gmyButtonDisabled: '='
      },
    };

    function link(scope, element) {
      function onAttributeChange(needDisabled) {
        if (needDisabled) {
          element.addClass('disabled');
          element.prop('disabled', true);
        } else {
          element.removeClass('disabled');
          element.prop('disabled', false);
        }

        element.prop('disabled', needDisabled);
      }

      scope.$watch('gmyButtonDisabled', onAttributeChange);
    }
  }
})();
